// extracted by mini-css-extract-plugin
export default {"header":"header-section_header__KOqD5","desc":"header-section_desc__ItQO4","small":"header-section_small__erFH2","padding":"header-section_padding__K9H2Y"};